import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ForgotPassword from '../../../redux/auth/components/ForgotPasswordForm';
import LoginForm from '../../../redux/auth/components/LoginForm';
import VerifyEmail from '../../../redux/auth/components/VerifyEmail';
import ResetPassword from '../../../redux/auth/components/ResetPassword';
import {
  CUSTOMER_LOGIN,
  CUSTOMER_REGISTRATION,
  FORGOT_PASSWORD,
  IFRAME_COMPONENT,
  LOGIN,
  PAYMENT_CANCLED,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
  RESET_PASSWORD,
  SUCCESS_PAGE,
  UNAUTHORIZE_BOOKING_AIRPORT,
  UNAUTHORIZE_BOOKING_AIRPORT_DETAILS,
  UNAUTHORIZE_BOOKING_PASSENGER_DETAILS,
  UNAUTHORIZE_BOOKING_SUMMARY,
  VENDOR_LOGIN,
  VENDOR_REGISTRATION,
  VERIFY_EMAIL,
  VERIFY_OTP,
} from './AppRoutes';
import CustomerRegistration from '../../../Screens/Customer/CustomerRegistration';
import VendorRegistration from '../../../Screens/Vendor/VendorRegistration';
import VerifyOTP from '../../../Screens/Customer/VerifyOTP';
import PaymentProcessingPage from '../../../Screens/Payment/PaymentProcessingPage';
import PaymentSuccess from '../../../Screens/Payment/PaymentSuccess';
import PaymentFailure from '../../../Screens/Payment/PaymentFailure';
import PaymentCancellation from '../../../Screens/Payment/PaymentCancle';

import UnAuthAirportDetails from '../../../Screens/UnAuthBooking/UnAuthAirportDetails';
import UnAuthPassengerDetails from '../../../Screens/UnAuthBooking/UnAuthPassengerDetails';
import UnAuthBookingSummary from '../../../Screens/UnAuthBooking/UnAuthBookingSummary';
import IframeComponent from '../../../Screens/UnAuthBooking/IframeComponent';
import AirportBookingForm1 from '../../../Screens/UnAuthBooking/AirportBookingForm1';
const UnauthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path={LOGIN} element={<LoginForm />} />
      <Route path={CUSTOMER_LOGIN} element={<LoginForm />} />
      <Route path={VENDOR_LOGIN} element={<LoginForm />} />
      <Route path={FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={VERIFY_EMAIL} element={<VerifyEmail />} />
      <Route path={RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={CUSTOMER_REGISTRATION} element={<CustomerRegistration />} />
      <Route path={VENDOR_REGISTRATION} element={<VendorRegistration />} />
      <Route path={VERIFY_OTP} element={<VerifyOTP />} />
      <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
      <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />
      <Route path={PAYMENT_PROCESSING} element={<PaymentProcessingPage />} />
      <Route path={PAYMENT_CANCLED} element={<PaymentCancellation />} />
      <Route
        path={UNAUTHORIZE_BOOKING_AIRPORT}
        element={<UnAuthAirportDetails />}
      />
      <Route
        path={UNAUTHORIZE_BOOKING_AIRPORT_DETAILS}
        element={<AirportBookingForm1/>}
      />
      <Route
        path={UNAUTHORIZE_BOOKING_PASSENGER_DETAILS}
        element={<UnAuthPassengerDetails />}
      />
      <Route
        path={UNAUTHORIZE_BOOKING_SUMMARY}
        element={<UnAuthBookingSummary />}
      />
       <Route path={IFRAME_COMPONENT} element={<IframeComponent />} />
    </Routes>
  );
};

export default UnauthenticatedRoutes;
